import type { client as isiaClient } from "../isia/client.gen";
import type { client as backofficeClient } from "../backoffice/client.gen";

export type ApiClient = typeof isiaClient | typeof backofficeClient;

export interface AuthAdapter {
  getAccessToken: () => string | undefined;
  refreshToken: (tokenAtTimeOf401?: string) => Promise<void>;
}

export interface ConfigureOptions {
  baseURL: string;
  auth: AuthAdapter;
}

const extractToken = (headers: HeadersInit | undefined): string | undefined => {
  if (!headers) return undefined;
  const authHeader =
    typeof (headers as Headers).get === "function"
      ? (headers as Headers).get("Authorization")
      : (headers as Record<string, string>)["Authorization"];
  return authHeader?.replace("Bearer ", "");
};

export function configureClient(client: ApiClient, options: ConfigureOptions) {
  client.setConfig({
    baseURL: options.baseURL,
    auth: () => options.auth.getAccessToken(),
    onRequest: async ({ options: reqOptions }) => {
      reqOptions.headers.set("Accept", "application/json");
      const token = options.auth.getAccessToken();
      if (token) {
        reqOptions.headers.set("Authorization", `Bearer ${token}`);
      }
    },
    onResponseError: async ({ response, options: reqOpts }) => {
      console.log("[heyapi] onResponseError déclenché", { status: response.status });
      if (response.status === 401) {
        try {
          await options.auth.refreshToken(extractToken(reqOpts.headers));
          console.log("[heyapi] refresh terminé depuis onResponseError → ofetch va retenter (retry:1)");
        } catch (error) {
          console.log("[heyapi] refresh KO depuis onResponseError → pas de retry", error instanceof Error ? error.message : String(error));
          throw error;
        }
      }
    },
    retry: 1,
    retryStatusCodes: [401],
    retryDelay: 500,
  });
}
